module.exports = __webpack_public_path__ + "resources/img/sp_common_m.4f6bff03aec1e550de02099992e5f867.png";